import React from 'react';
import NavBar from '../NavBar';
import { Logo } from '../ui/Logo';
import { useTranslation } from 'react-i18next';

interface OuterLayoutProps {
  children: React.ReactNode;
}

export default function OuterLayout({ children }: OuterLayoutProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <NavBar />
      
      <main id="main-content" className="container mx-auto px-4 py-8">
        {children}
      </main>
      
      <footer className="border-t bg-muted/30 mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-center space-x-2 text-muted-foreground">
            <Logo 
              variant="dark" 
              size={16} 
              className="opacity-60"
            />
            <span className="text-sm">
              {t('layout.copyright', { ns: 'common', year: new Date().getFullYear() })}
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
} 